import { createElement } from "@wordpress/element";
/**
 * WordPress dependencies
 */

import { withSelect } from '@wordpress/data';
/**
 * Internal dependencies
 */

import BlockMover from '../block-mover';

function BlockListMultiControls(_ref) {
  var multiSelectedBlockClientIds = _ref.multiSelectedBlockClientIds,
      isSelecting = _ref.isSelecting,
      moverDirection = _ref.moverDirection;

  if (isSelecting) {
    return null;
  }

  return createElement(BlockMover, {
    clientIds: multiSelectedBlockClientIds,
    __experimentalOrientation: moverDirection
  });
}

export default withSelect(function (select) {
  var _select = select('core/block-editor'),
      getMultiSelectedBlockClientIds = _select.getMultiSelectedBlockClientIds,
      isMultiSelecting = _select.isMultiSelecting;

  var clientIds = getMultiSelectedBlockClientIds();
  return {
    multiSelectedBlockClientIds: clientIds,
    isSelecting: isMultiSelecting()
  };
})(BlockListMultiControls);